<template>
    <div class="sidebar">
        <el-menu
            class="sidebar-el-menu"
            :default-active="onRoutes"
            :collapse="collapse"
            text-color="#666"
            active-text-color="#409EFF"
            unique-opened
            router
        >
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.title }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu
                                v-if="subItem.subs"
                                :index="subItem.index"
                                :key="subItem.index"
                            >
                                <template slot="title">{{ subItem.title }}</template>
                                <el-menu-item
                                    v-for="(threeItem,i) in subItem.subs"
                                    :key="i"
                                    :index="threeItem.index"
                                >{{ threeItem.title }}</el-menu-item>
                            </el-submenu>
                            <el-menu-item
                                v-else
                                :index="subItem.index"
                                :key="subItem.index"
                            >{{ subItem.title }}</el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon"></i>
                        <span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
import bus from './bus';
export default {
    data() {
        return {
            collapse: false,
            items: [],
            itemszb: [
                {
                    icon: 'el-icon-lx-apps',
                    index: '/branchmgment',
                    title: '分支机构管理'
                },
                {
                    icon: 'el-icon-lx-people',
                    index: '/headadmin',
                    title: '总部管理员管理'
                },
                {
                    icon: 'el-icon-lx-rank',
                    index: '/manufacturerorganizations',
                    title: '厂商管理'
                },
                {
                    icon: 'el-icon-lx-profile',
                    index: '/manufacturerbusinessperson',
                    title: '厂商业务员管理'
                },
                {
                    icon: 'el-icon-lx-group',
                    index: '/headbusinesspersons',
                    title: '总部业务员管理'
                },
                {
                    icon: 'el-icon-tickets',
                    index: '/licenseapplys/first/1',
                    title: '牌照查看'
                },
                {
                    icon: 'el-icon-document',
                    index: '/licensecheck',
                    title: '牌照审核',
                    subs: [
                        {
                            index: '/licensecheckxcx/first/1',
                            title: '小程序用户'
                        },
                        {
                            index: '/licensecheckfzorgan/first/1',
                            title: '分支机构'
                        },
                        {
                            index: '/licensecheckzbperson/first/1',
                            title: '总部业务员'
                        },
                        {
                            index: '/licensecheckjxshop/first/1',
                            title: '厂商业务员'
                        }
                    ]
                },
                {
                    icon: 'el-icon-lx-edit',
                    index: '/certificateapplys/cerfirst/1',
                    title: '操作证查看'
                },
                {
                    icon: 'el-icon-lx-calendar',
                    index: '/certificatecheck',
                    title: '操作证审核',
                    subs: [
                        {
                            index: '/certificatecheckfzorgan/checkfirst/1',
                            title: '分支机构'
                        },
                        {
                            index: '/certificatecheckxcx/checkfirst/1',
                            title: '小程序用户'
                        },

                        {
                            index: '/certificatecheckzbperson/checkfirst/1',
                            title: '总部业务员'
                        },
                        {
                            index: '/certificatecheckjxshop/checkfirst/1',
                            title: '厂商业务员'
                        }
                    ]
                },
                {
                    icon: 'el-icon-alarm-clock',
                    index: '/orderinfo',
                    title: '预约信息',
                    subs: [
                        {
                            index: '/orderlicense',
                            title: '牌照预约'
                        },
                        {
                            index: '/ordercertificate',
                            title: '证书预约'
                        }
                    ]
                },
                {
                    icon: 'el-icon-lx-news',
                    index: '/consults',
                    title: '资讯管理'
                },
                {
                    icon: 'el-icon-lx-file',
                    index: '/articles',
                    title: '学习资料管理'
                },
                {
                    icon: 'el-icon-lx-question',
                    index: '/questions',
                    title: '证书考试管理'
                },

                {
                    icon: 'el-icon-copy-document',
                    index: '/organizationlicenseapply',
                    title: '牌证申请审核'
                },
                {
                    icon: 'el-icon-lx-attention',
                    index: '/organizationapplicationlook',
                    title: '牌证申请历史'
                },

                {
                    icon: 'el-icon-connection',
                    index: '/licencerelation',
                    title: '牌照关系维护'
                },
                {
                    icon: 'el-icon-postcard',
                    index: '/livingdemands',
                    title: '货源信息管理'
                },
                {
                    icon: 'el-icon-set-up',
                    index: '/usedcars',
                    title: '二手车信息管理'
                }
            ],
            itemszbpt: [
                {
                    icon: 'el-icon-tickets',
                    index: '/licenseapplys/1',
                    title: '牌照查看'
                },
                {
                    icon: 'el-icon-document',
                    index: '/licensecheck',
                    title: '牌照审核',
                    subs: [
                        {
                            index: '/licensecheckxcx',
                            title: '小程序用户'
                        },
                        {
                            index: '/licensecheckfzorgan',
                            title: '分支机构'
                        },
                        {
                            index: '/licensecheckzbperson',
                            title: '总部业务员'
                        },
                        {
                            index: '/licensecheckjxshop',
                            title: '厂商业务员'
                        }
                    ]
                },
                {
                    icon: 'el-icon-lx-edit',
                    index: '/certificateapplys/1',
                    title: '操作证查看'
                },
                {
                    icon: 'el-icon-lx-calendar',
                    index: '/certificatecheck',
                    title: '操作证审核',
                    subs: [
                        {
                            index: '/certificatecheckfzorgan',
                            title: '分支机构'
                        },
                        {
                            index: '/certificatecheckxcx',
                            title: '小程序用户'
                        },

                        {
                            index: '/certificatecheckzbperson',
                            title: '总部业务员'
                        },
                        {
                            index: '/certificatecheckjxshop',
                            title: '厂商业务员'
                        }
                    ]
                }
            ],
            itemszbdy: [
                {
                    icon: 'el-icon-tickets',
                    index: '/licenseapplys',
                    title: '牌照查看'
                },
                {
                    icon: 'el-icon-lx-edit',
                    index: '/certificateapplys',
                    title: '操作证查看'
                }
            ],
            itemsfz: [
                {
                    icon: 'el-icon-lx-apps',
                    index: '/fzorganadmin',
                    title: '分支机构业务员管理'
                },
                {
                    icon: 'el-icon-tickets',
                    index: '/fzorganlicenseapplys/third/1',
                    title: '牌照查看'
                },
                {
                    icon: 'el-icon-document',
                    index: '/fzorganhistory/first/1',
                    title: '牌照审核中'
                },
                {
                    icon: 'el-icon-lx-edit',
                    index: '/fzorgancertificateapplys/cersecond/1',
					// index: '/fzorgancertificateapply',
                    title: '操作证查看'
                },
                {
                    icon: 'el-icon-lx-calendar',
                    index: '/operationhistory/checkfirst/1',
                    title: '操作证审核中'
                },
                {
                    icon: 'el-icon-lx-attention',
                    index: '/fzorganapplicationlook',
                    title: '牌证申请历史'
                }
            ]
				};
    },
    computed: {
        onRoutes() {
            return this.$route.path.replace('', '');
        }
    },
    created() {
        var organizationKind = localStorage.getItem('organizationKind');
        var role = localStorage.getItem('role');
        if (organizationKind == 2) {
            if (role == 1) {
                this.items = this.itemszb;
            } else if (role == 2) {
                this.items = this.itemszbpt;
            } else if (role == 3) {
                this.items = this.itemszbdy;
            }
        } else {
						if(role == 20) {
							this.items = this.itemsfz.filter(item=>item.title!='分支机构业务员管理');
						}else {
							this.items = this.itemsfz;
						}
        }

        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on('collapse', msg => {
            this.collapse = msg;
            bus.$emit('collapse-content', msg);
        });
    }
};
</script>

<style scoped>
.sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 70px;
    bottom: 0;
    overflow-y: scroll;
}
.sidebar::-webkit-scrollbar {
    width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
    width: 210px;
}
.sidebar > ul {
    height: 100%;
}
</style>
